
import { Button } from "@/components/ui/button";
import { Loader2, Save } from "lucide-react";

interface JournalFormActionsProps {
  onSubmit: (e: React.FormEvent) => void;
  isLoading: boolean;
  disabled?: boolean;
}

export function JournalFormActions({ 
  onSubmit, 
  isLoading,
  disabled = false
}: JournalFormActionsProps) {
  return (
    <div className="flex justify-end">
      <Button
        type="submit"
        className="bg-blue-700 hover:bg-blue-800 text-white"
        onClick={onSubmit}
        disabled={isLoading || disabled}
      >
        {isLoading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Saving...
          </>
        ) : (
          <>
            <Save className="mr-2 h-4 w-4" />
            Save Entry
          </>
        )}
      </Button>
    </div>
  );
}
